import { timeFormatterFromMilliseconds } from "helpers/sf_utils";
import React from "react";
import { Col, Row } from "reactstrap";

const PlayerTimestamps = ({ converedCallDuration, total_call_duration }) => {
    return (
        <Row>
            <Col className="d-flex align-items-center justify-content-center mb-3 font-weight-semibold">
                { timeFormatterFromMilliseconds(converedCallDuration.covered_call_duration_milliseconds ) } / { timeFormatterFromMilliseconds(total_call_duration.total_call_duration_milliseconds) }
            </Col>
        </Row>
    )
}

export default PlayerTimestamps;